// extracted by mini-css-extract-plugin
export default {"content":"style_content__J00My","leftSide":"style_leftSide__rp4w+","rightSide":"style_rightSide__k42ac","type":"style_type__zoZek"};